import { render, staticRenderFns } from "./ShowNMICAnswersCard.vue?vue&type=template&id=5e3d596b&scoped=true&"
import script from "./ShowNMICAnswersCard.vue?vue&type=script&lang=js&"
export * from "./ShowNMICAnswersCard.vue?vue&type=script&lang=js&"
import style0 from "./ShowNMICAnswersCard.vue?vue&type=style&index=0&id=5e3d596b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3d596b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VChip,VIcon})
